export const USR_FETCH = 'USR_FETCH';
export const USR_FETCH_ERROR = 'USR_FETCH_ERROR';
export const USR_FETCH_SUCCESS = 'USR_FETCH_SUCCESS';
export const USR_REMOVE_FETCH = 'USR_REMOVE_FETCH';
export const USR_REMOVE_FETCH_ERROR = 'USR_REMOVE_FETCH_ERROR';
export const USR_REMOVE_FETCH_SUCCESS = 'USR_REMOVE_FETCH_SUCCESS';

export const userFetch = (organizationId, userId) => ({
  type: USR_FETCH,
  payload: { organizationId, userId },
});

export const userFetchSuccess = userId => ({
  type: USR_FETCH_SUCCESS,
  payload: userId,
});

export const userFetchError = error => ({
  type: USR_FETCH_ERROR,
  payload: error,
});

/** `onSuccess` runs once the document is gone, e.g. to re-read a list that is not live. */
export const userRemoveFetch = (organizationId, userId, onSuccess) => ({
  type: USR_REMOVE_FETCH,
  payload: { organizationId, userId, onSuccess },
});

export const userRemoveFetchSuccess = user => ({
  type: USR_REMOVE_FETCH_SUCCESS,
  payload: user,
});

export const userRemoveFetchError = error => ({
  type: USR_REMOVE_FETCH_ERROR,
  payload: error,
});
